import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class WaterSportsService {

    static getwatersportsList(item) {
        if (item?.id) {
          const api = `${API_BASE_URL}${API_PATHS.getwaterSports}?id=${item.id}`;
          return axiosInstance.get(api);
        }
      
        if (item?.place) {
          const api = `${API_BASE_URL}${API_PATHS.getwaterSports}?place=${item.place}&limit=${item.limit}&page=${item.page}`;
          return axiosInstance.get(api);
        }
      
        const api = `${API_BASE_URL}${API_PATHS.getwaterSports}?limit=${item?.limit}&page=${item?.page}`;
        return axiosInstance.get(api);
      }
      

  
static addwaterSports(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addwaterSports}`;
    return axiosInstance
        .post(api,item)
        
}

static editwaterSports(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editwaterSports}`;
    return axiosInstance
        .put(api,item)
        
}
static deleteWaterSports(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deletewaterSports}?id=${item?.id}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default WaterSportsService;